export default {
  /*站点配置缓存 */
  shoppingcartKey:'__xr_purchase_shoppingcart',  
  addItem : function(skuId, count){
    if(typeof(skuId) != 'number' || typeof(count) != 'number'){
      return
    }

    var list = this.getList()    
    var item = {}
    for(var i = 0 ; i < list.length;i++){
      if(list[i].skuId == skuId){
        item = list[i]
      }
    }
    if(item.skuId>0){
      item.count += count
    }else{
      item = {skuId:skuId, count: count , select: true}
      list.push(item)
    }
    list = JSON.stringify(list)
    window.localStorage.setItem(this.shoppingcartKey, list)
  },
  minusItem:function(skuId){
    if(typeof(skuId) != 'number'){
      return
    }

    var list = this.getList()    
    var item = {}
    for(var i = 0 ; i < list.length;i++){
      if(list[i].skuId == skuId){
        item = list[i]
      }
    }
    if(item.skuId>0){
      item.count -= 1
    }
    if(item.count ==0){
      this.removeItem(skuId)
      return
    }
    list = JSON.stringify(list)
    window.localStorage.setItem(this.shoppingcartKey, list)
  }, 
  checkItem: function(skuId, checked){
    if(typeof(skuId) != 'number' || typeof(checked) != 'boolean'){
      return
    }
    
    var list = this.getList()    
    var item = {}
    for(var i = 0 ; i < list.length;i++){
      if(list[i].skuId == skuId){
        item = list[i]
      }
    }
    if(item.skuId>0){
      item.select = checked
      list = JSON.stringify(list)
      window.localStorage.setItem(this.shoppingcartKey, list)
    }
  },
  removeItem:function(skuId){
    if(typeof(skuId) != 'number'){
      return
    }

    var list = this.getList()    
    var newList = []
    for(var i = 0 ; i < list.length;i++){
      if(list[i].skuId != skuId){
        newList.push(list[i])
      }
    }    
    list = JSON.stringify(newList)
    window.localStorage.setItem(this.shoppingcartKey, list)
  },
  getItem : function(skuId){
    var list = this.getList()    
    var item = {}
    for(var i = 0 ; i < list.length;i++){
      if(list[i].skuId == skuId){
        item = list[i]
      }
    }
    return item
  },
  getList : function(){
    var list = window.localStorage.getItem(this.shoppingcartKey)
    if(!list){
      return []
    }
    if(typeof(list) != 'object'){
      list = JSON.parse(list)
    }
    return list
  }, 
  getSelectList : function(){
    var list = this.getList()

    var newList = []
    for(var i = 0; i < list.length ; i++){
      if(list[i].select){
        newList.push(list[i])
      }
    }

    return newList
  }, 
  getCount : function(){
    var count = 0;
    var list = this.getList()
    for(var i = 0; i < list.length; i++){
      count += list[i].count
    }
    return count
  },
  clearList : function(){
    window.localStorage.removeItem(this.shoppingcartKey)
  },
  clearSelectList : function(){
    var list = this.getList()

    var newList = []
    for(var i = 0; i < list.length ; i++){
      if(!list[i].select){
        newList.push(list[i])
      }
    }
    if(newList.length == 0){
      this.clearList()
    }
    else{      
      newList = JSON.stringify(newList)
      window.localStorage.setItem(this.shoppingcartKey, newList)
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/purchaseCart.js